import { FETCH_MANAGER_MONTHDATA_SUCCESS } from "../Constants";

const initialAuthState = {
  payload: {}
};

export default (state = initialAuthState, action) => {
  switch (action.type) {
    case FETCH_MANAGER_MONTHDATA_SUCCESS:
      return {
        payload: action.data
      };

    default:
      return state;
  }
};
